const { REACT_APP_AIRTABLE_API_KEY, REACT_APP_AIRTABLE_API_URL } = process.env;

export const retrieveRequests = (id) => {
	return fetch(REACT_APP_AIRTABLE_API_URL + '/PTO_Requests?filterByFormula=employeeId="' + id + '"&sort%5B0%5D%5Bfield%5D=dateRequested&sort%5B0%5D%5Bdirection%5D=asc', {
		method: 'GET',
		headers: {
			'Authorization': 'Bearer ' + REACT_APP_AIRTABLE_API_KEY,
		}
	})
		.then(resp => resp.json())
		.then(json => json);
}


// WEBPACK FOOTER //
// ./src/utils/retrieveRequests.js